module.exports = __webpack_public_path__ + "static/media/16UNODC30.912d83d4.jpg";